<template>
  <div class="info-section">
    <BerkasPendaftaran v-if="berkas" />
    <SyaratPendaftaran v-if="syarat" />
    <Administrasi v-if="administrasi" />
    <Jurusan v-if="jurusan" />
    <RincianPembayaran v-if="rincianPembayaran" />
    <!-- <TesMasuk v-if="tesMasuk" /> -->
  </div>
</template>

<script>
import BerkasPendaftaran from "../components/Informasi/BerkasPendaftaran";
import SyaratPendaftaran from "../components/Informasi/Syarat";
import Administrasi from "../components/Informasi/Administrasi";
// import TesMasuk from "../components/Informasi/TesMasuk";
import Jurusan from "../components/Informasi/Jurusan";
import RincianPembayaran from "../components/Informasi/RincianPembayaran";

export default {
  data: () => ({
    berkas: false,
    syarat: false,
    administrasi: false,
    tesMasuk: false,
    informasi: false,
    jurusan: false,
    rincianPembayaran: false,
  }),
  components: {
    BerkasPendaftaran,
    SyaratPendaftaran,
    Administrasi,
    // TesMasuk,
    Jurusan,
    RincianPembayaran,
  },
  created() {
    this.$watch(
      () => {
        this.$route;
        return {};
      },
      () => {
        this.checkRoute();
      }
    );
  },
  mounted() {
    const info = this.$route.params.info;

    if (info === "tes-masuk") this.tesMasuk = true;
    else if (info === "berkas-pendaftaran") this.berkas = true;
    else if (info === "syarat-pendaftaran") this.syarat = true;
    else if (info === "administrasi-pembayaran") this.administrasi = true;
    else if (info === "jurusan") this.jurusan = true;
    else if (info === "rincian-pembayaran") this.rincianPembayaran = true;

    this.checkRoute();
  },
  methods: {
    checkRoute() {
      if (this.$route.params.info == "pengumuman-seleksi") {
        if (localStorage.getItem("id")) {
          window.location.href = `https://dev-api-ppdb.smkruskudus.com/preview/${localStorage.getItem(
            "id"
          )}?type=PENGUMUMAN`;
        }
        this.$router.push({
          name: "informasi",
        });
      }
    },
  },
};
</script>

<style scoped>
.info-section {
  min-height: 80vh;
}
</style>